import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import { useAuthGlobal } from "../../../../../../contexts/auth-context/auth-context";

import { FilterModel } from "../../../../../../domain/models/enum";

import InvoiceListPage from "../../../../../../presentation/pages/developer/foreign-note/list";

import { settings } from "../../../../../configs/settings";

import { makeRemoteDocument } from "../../../../usecases/documents/remote-documents-factory";
import { DocumentsResponseModel } from "../../../../../../domain/models/documents";

function MakeForeignNoteList(): JSX.Element {
  const { profile, user } = useAuthGlobal();
  const [list, setList] = useState<DocumentsResponseModel>();
  const [params, setParams] = useState<FilterModel>({});
  const [loading, setLoading] = useState<boolean>();
  const [reload, setReload] = useState<boolean>(false);

  const loadData = async (): Promise<void> => {
    try {
      setLoading(true);

      const data = await makeRemoteDocument().load({
        size: settings.perPage,
        sort: "id,desc",
        page: params?.page || 0,
        query: params?.query,
        filters: [
          "type=FISCAL_NOTE_FOREIGN",
          ...(params?.status && params?.status !== 0
            ? [`status=${params.status}`]
            : []),
        ],
      });
      setList(data);
    } catch (error) {
      console.error(error);
      toast.error("Erro ao carregar notas para o exterior");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, profile, user, reload]);

  const handleReload = (): void => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleReload();
    }, 180000);
    return () => clearInterval(interval);
  }, []);

  return (
    <InvoiceListPage
      // params={params}
      list={list}
      setParams={setParams}
      loading={loading}
      handleReload={handleReload}
      isSuperAdmin={!!user?.roles?.find((r: any) => r.authority === "SUPERADMIN")}
    />
  );
}

export default MakeForeignNoteList;
